import { render, staticRenderFns } from "./TabEducation.vue?vue&type=template&id=1663007b&scoped=true&"
import script from "./TabEducation.vue?vue&type=script&lang=js&"
export * from "./TabEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1663007b",
  null
  
)

export default component.exports